module.exports = __webpack_public_path__ + "media/applicants/instacart-logo-wordmark-transparent-d5dbd735.png";